import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { post } from '../../utils/ApiRequest';
import { format } from 'date-fns';

function ProjectAssignmentDetail() {
  const { projectId } = useParams();
  const location = useLocation();
  const project = location.state || {}; // ProjectAssignmentList에서 전달받은 프로젝트 정보

  const storedUser = sessionStorage.getItem('user');
  const user = storedUser && JSON.parse(storedUser);

  
  const [assignmentDetails, setAssignmentDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const organizationCode = user?.organizationCode || '';
  const [currentAssignment, setCurrentAssignment] = useState({
    projectId: project?.projectId || '',
    projectName: project?.projectName || '',
    client: project?.client || '',
    assignmentId: '',
    userEmail: '',
    userName: '',
    task: '',
    startDate: '',
    endDate: '',
    month: '', // 월별 투입 정보
  });
  const [userList, setUserList] = useState([]); // 전체 사용자 목록
  const [selectedUser, setSelectedUser] = useState(null); // 모달에서 선택된 사용자

  useEffect(() => {
    const fetchAssignmentDetails = async () => {
      try {
        const response = await post('/project/readProjectAssignmentList', projectId, {
          Authorization: `Bearer ${user.jwt}`,
        });
        const data = await response.json();
        setAssignmentDetails(data);
      } catch (error) {
        console.log(error);
        alert('인력 투입 상세 정보를 불러오는 데 실패했습니다.');
      }
    };

    fetchAssignmentDetails();
  }, [projectId, user?.jwt]);

  const handleAddEdit = async (assignment = null) => {
    console.log('[IN] assignment param =', assignment); // ✅ 이걸 먼저 찍어 실제로 뭐가 왔는지 확인
    console.log(currentAssignment);
    // 사용자 목록을 모달이 열릴 때만 불러옵니다.
    try {
      const response = await post('/user/readEmployeeList', organizationCode, {
        Authorization: `Bearer ${user.jwt}`,
      });
      const data = await response.json();
      // 가입 반려자는 조직 구성원이 아니므로 인원 선택 목록에서 제외
      setUserList((data || []).filter(u => !u.rejected));
    } catch (error) {
      console.log(error);
      alert('사용자 목록을 불러오는 데 실패했습니다.');
    }

    if (assignment) {
      setCurrentAssignment({
        ...assignment,
        assignmentId: assignment.projectInfoId,
        startDate: toInputDate(assignment.startDate),
        endDate: toInputDate(assignment.endDate)
      });
      setSelectedUser({ userEmail: assignment.userEmail, userName: assignment.userName });
      console.log("after :", currentAssignment);
    } else {
      setCurrentAssignment({
        projectId: project?.projectId || '',
        projectName: project?.projectName || '',
        client: project?.client || '',
        assignmentId: '',
        userEmail: '',
        userName: '',
        task: '',
        startDate: '',
        endDate: '',
        month: '',
      });
      setSelectedUser(null);
    }
    setShowModal(true);
  };

  const handleDelete = async (assignmentId) => {
    if (window.confirm('정말로 이 인력 투입 정보를 삭제하시겠습니까?')) {
      try {
        // UserProjectInfo 객체를 통째로 보내야 할 수도 있습니다. 여기서는 assignmentId만 보냅니다.
        // 백엔드 API 명세를 확인하여 정확한 요청 본문 형태를 맞춰야 합니다.
        const response = await post('/user/deleteUserProjectInfo', { projectInfoId: assignmentId }, {
          Authorization: `Bearer ${user.jwt}`,
        });
        if (response.ok) {
          alert('삭제되었습니다.');
          // 데이터 새로고침
          const fetchAssignmentDetails = async () => {
            try {
              const response = await post('/project/readProjectAssignmentList', projectId, {
                Authorization: `Bearer ${user.jwt}`,
              });
              const data = await response.json();
              setAssignmentDetails(data);
            } catch (error) {
              console.log(error);
              alert('인력 투입 상세 정보를 불러오는 데 실패했습니다.');
            }
          };
          fetchAssignmentDetails();
        } else {
          alert('삭제 실패');
        }
      } catch (error) {
        console.error(error);
        alert('오류 발생');
      }
    }
  };

  const handleSave = async () => {
    if (!selectedUser) {
      alert('인력을 선택해주세요.');
      return;
    }

    try {
      const response = await post('/project/saveProjectAssignment', {
        ...currentAssignment,
        userEmail: selectedUser.userEmail,
        userName: selectedUser.userName,
      }, {
        Authorization: `Bearer ${user.jwt}`,
      });
      if (response.ok) {
        alert('저장되었습니다.');
        // 데이터 새로고침
        const fetchAssignmentDetails = async () => {
          try {
            const response = await post('/project/readProjectAssignmentList', projectId, {
              Authorization: `Bearer ${user.jwt}`,
            });
            const data = await response.json();
            setAssignmentDetails(data);
          } catch (error) {
            console.log(error);
            alert('인력 투입 상세 정보를 불러오는 데 실패했습니다.');
          }
        };
        fetchAssignmentDetails();
        setShowModal(false);
      } else {
        alert('저장 실패');
      }
    } catch (error) {
      console.error(error);
      alert('오류 발생');
    }
  };

  const toInputDate = (value) => {
    if (!value) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value; // 이미 yyyy-MM-dd면 그대로
    const d = new Date(value); // value가 '...+09:00' 이든 ISO이든 OK(로컬로 보정됨)
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f8ff' }}>
      <div className="mb-4 shadow-sm card">
      <h5 className="card-header-custom d-flex justify-content-between align-items-center card-header">
        <span>프로젝트: {project.projectName || projectId} - 인력 투입 상세</span>
        <button className="btn-main-action btn" onClick={() => handleAddEdit()}>인력 추가</button>
      </h5>
      <div className="card-body">
        <div className="table-responsive">
          <table className="text-center align-middle table table-striped table-bordered table-hover">
            <thead className="table-dark-custom">
              <tr>
                <th>이름</th>
                <th>직책/역할</th>
                <th>시작일</th>
                <th>종료일</th>
                <th>M/M</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {assignmentDetails.map((detail) => (
                <tr key={detail.projectInfoId}>
                  <td>{detail.userName}</td>
                  <td>{detail.task}</td>
                  <td>{format(new Date(detail.startDate), 'yyyy-MM-dd')}</td>
                  <td>{format(new Date(detail.endDate), 'yyyy-MM-dd')}</td>
                  <td>{detail.month}</td>
                  <td>
                    <div role="group" className="btn-group btn-group-sm">
                      <button className="btn btn-outline-secondary" onClick={() => handleAddEdit(detail)}>수정</button>
                      <button className="btn btn-outline-danger" onClick={() => handleDelete(detail.projectInfoId)}>삭제</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

      {/* Modal for Add/Edit */}
      {showModal && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }} aria-hidden="false">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">인력 투입 {currentAssignment.assignmentId ? '수정' : '등록'}</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <h5>전체 사용자</h5>
                    <ul className="list-group" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {userList.map((userItem) => (
                        <li
                          key={userItem.userEmail}
                          className={`list-group-item list-group-item-action ${selectedUser?.userEmail === userItem.userEmail ? 'active' : ''}`}
                          onClick={() => setSelectedUser(userItem)}
                        >
                          {userItem.userName} ({userItem.userEmail})
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h5>선택된 사용자</h5>
                    <ul className="list-group" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {selectedUser && (
                        <li className="list-group-item">
                          {selectedUser.userName} ({selectedUser.userEmail})
                          <button
                            className="btn btn-sm btn-danger float-end"
                            onClick={() => setSelectedUser(null)}
                          >
                            X
                          </button>
                        </li>
                      )}
                      {!selectedUser && (
                        <li className="list-group-item text-muted">사용자를 선택해주세요.</li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="mb-3 mt-3">
                  <label htmlFor="task" className="form-label">직책/역할</label>
                  <input type="text" className="form-control" id="task" name="task" value={currentAssignment.task} onChange={(e) => setCurrentAssignment({ ...currentAssignment, task: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label htmlFor="startDate" className="form-label">시작일</label>
                  <input type="date" className="form-control" id="startDate" name="startDate" value={currentAssignment.startDate} onChange={(e) => setCurrentAssignment({ ...currentAssignment, startDate: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label htmlFor="endDate" className="form-label">종료일</label>
                  <input type="date" className="form-control" id="endDate" name="endDate" value={currentAssignment.endDate} onChange={(e) => setCurrentAssignment({ ...currentAssignment, endDate: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label htmlFor="month" className="form-label">M/M (0 ~ 1)</label>
                  <input type="number" className="form-control" id="month" name="month" min="0" max="1" step="0.01" value={currentAssignment.month} onChange={(e) => setCurrentAssignment({ ...currentAssignment, month: e.target.value })} />
                </div>
              </div>
              <div className="modal-footer">
                <div className="button-container">
                  <button type="button" className="btn btn-primary" onClick={handleSave}>저장</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>취소</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectAssignmentDetail;